import React from 'react';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import CodeIcon from '@mui/icons-material/Code';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Editor, EditorContent } from '@tiptap/react';
import VeraPromptContextGuide from '../VeraPromptContextGuide';
import { getVeraPromptContextGuide } from '../veraPromptContextGuides';
import { VeraPromptEditorToolbar } from '../veraPromptEditorUtils';
import { StyledLabel } from '../../styles/styles';
import { MONOSPACE_TEXTAREA_STYLE } from '../VeraAdminChatAssistPromptSandbox/adminAssistPromptStyles';
import { TIPTAP_EDITOR_SX } from './investorPromptStyles';

interface InvestorSystemPromptTabProps {
  markdown: string;
  rawMode: boolean;
  onRawModeChange: (raw: boolean) => void;
  onMarkdownChange: (value: string) => void;
  onRawBlur: () => void;
  editor: Editor | null;
  globalGuideOptions: { googleSearchEnabled: boolean; googleSearchLinksEnabled: boolean };
}

export default function InvestorSystemPromptTab({
  markdown,
  rawMode,
  onRawModeChange,
  onMarkdownChange,
  onRawBlur,
  editor,
  globalGuideOptions,
}: InvestorSystemPromptTabProps) {
  return (
    <>
      <VeraPromptContextGuide
        markdown={getVeraPromptContextGuide('global_system', globalGuideOptions)}
      />
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <StyledLabel stacked>Proposed Markdown</StyledLabel>
          <ToggleButtonGroup
            size="small"
            exclusive
            value={rawMode ? 'raw' : 'rich'}
            onChange={(_, value) => value && onRawModeChange(value === 'raw')}
          >
            <ToggleButton value="rich">
              <AutoAwesome sx={{ fontSize: 16, mr: 0.5 }} />
              Rich
            </ToggleButton>
            <ToggleButton value="raw">
              <CodeIcon sx={{ fontSize: 16, mr: 0.5 }} />
              Raw
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>

        {rawMode ? (
          <textarea
            value={markdown}
            onChange={(event) => onMarkdownChange(event.target.value)}
            onBlur={onRawBlur}
            rows={20}
            style={MONOSPACE_TEXTAREA_STYLE}
          />
        ) : (
          <Box sx={TIPTAP_EDITOR_SX} onClick={() => editor?.commands.focus()}>
            <VeraPromptEditorToolbar editor={editor} />
            <EditorContent editor={editor} />
          </Box>
        )}
      </Box>
    </>
  );
}
